import type { VisualSettings } from './Settings.js';

/** Live diagnostic flags — leaf modules read these without importing main. */
export const DIAGNOSTIC = {
  ENABLE_SHADOWS: true,
  ENABLE_POSTFX: true,
  ENABLE_SKY: true,
  ENABLE_TERRAIN_SHADING: true,
  ENABLE_VEHICLE_FX: true,
  ENABLE_CAMERA_MODS: true,
  /** No smoothing when camera mods are off — makes bumps obvious. Not exposed in UI. */
  BUMP_EXAGGERATE: false,
};

export function applyDiagnosticFromSettings(settings: VisualSettings): void {
  DIAGNOSTIC.ENABLE_SHADOWS = settings.diagShadowsEnabled;
  DIAGNOSTIC.ENABLE_POSTFX = settings.diagPostFxEnabled;
  DIAGNOSTIC.ENABLE_SKY = settings.diagSkyEnabled;
  DIAGNOSTIC.ENABLE_TERRAIN_SHADING = settings.diagTerrainShadingEnabled;
  DIAGNOSTIC.ENABLE_VEHICLE_FX = settings.diagVehicleFxEnabled;
  DIAGNOSTIC.ENABLE_CAMERA_MODS = settings.diagCameraModsEnabled;
}
